// This file contains the environment variables for the production environment.
export const prodEnv = {
  API_URL: "https://music-backend-6zy2sae4zq-uc.a.run.app",
};

// // Uncomment the following lines if you want to use a local API URL for development.
// export const prodEnv = {
//   API_URL: "http://localhost:3000",
// };
